(function () {
  var modal = document.getElementById('quote-modal');
  if (!modal) return;

  var email = modal.dataset.quoteEmail || 'contact@pro.quelbonplan.fr';
  var emailLink = modal.querySelector('[data-quote-email-link]');

  function openModal(title) {
    title = title || '';
    if (emailLink) {
      var subject = 'Demande devis "' + title + '"';
      var body = 'Bonjour je suis intéressé par "' + title + '" merci';
      emailLink.setAttribute(
        'href',
        'mailto:' + email + '?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body)
      );
    }
    modal.hidden = false;
    document.body.classList.add('is-quote-modal-open');
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('is-quote-modal-open');
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var trigger = e.target.closest('[data-quote-request]');
    if (trigger) {
      e.preventDefault();
      openModal(trigger.dataset.productTitle);
      return;
    }
    if (e.target.closest('[data-quote-close]')) {
      closeModal();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });

  // mailto: doesn't unload the page — dismiss the modal once the mail client is invoked.
  if (emailLink) {
    emailLink.addEventListener('click', function () {
      setTimeout(closeModal, 0);
    });
  }
})();
